// import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import Cookies from 'js-cookie';
// import axios from 'axios';
// import Lottie from 'lottie-react';
// import front from '../Animations/front.json';
// import { Menu, X } from "lucide-react";
// import logo from '../assets/kids.png'
// const KidsZonePro = () => {
//   const navigate = useNavigate();
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [selectedLanguage, setSelectedLanguage] = useState("en"); 
//   const msisdn = Cookies.get('kidszonepro_user');
  
//   useEffect(() => {
//     if (msisdn) {
//       navigate('/');
//     } else {
//       axios.get('http://localhost:9161/getheaders')
//         .then(response => {
//           const data = response.data;
//           if (data.status == '1') {
//             Cookies.set('kidszonepro_user', data.msisdn, { expires: 1 });
//             Cookies.set('status', data.status, { expires: 1 });
//             navigate('/');
//           }
//         })
//         .catch(error => console.error("Error fetching data:", error));
//     }
//   }, [msisdn, navigate]);

//   const handleSubscribe = () => {
//     window.location.href = "http://consent.hutch.lk/register-service/VA%3D%3DCQ%3D%3DdQ%3D%3D";
//   };

//   const translations = {
//     en: {
//       title: "KIDSZONE PRO",
//       subtitle: "Fun Learning for Kids",
//       subscribeInfo1: "Subscribe to KidsZone Pro service",
//       subscribeInfo2: "You will be charged Rs. 6+tax/1 apply",
//       subscribe: "Subscribe",
//       dropdownSubscribe: "Subscribe to Daily",
//       dropdownTerms: "Terms & Conditions",
//     },
//     si: {
//       title: "KIDSZONE PRO",
//       subtitle: "දරුවන් සඳහා විනෝදය සහ ඉගෙනුම",
//       subscribeInfo1: "KidsZone Pro සේවාවට දායක වන්න",
//       subscribeInfo2: "ඔබට Rs. 6+බදු/1 අය වේ",
//       subscribe: "සක්‍රිය කරන්න",
//       dropdownSubscribe: "සක්‍රිය කරන්න",
//       dropdownTerms: "නියම සහ කොන්දේසි",
//     },
//     ta: {
//       title: "KIDSZONE PRO",
//       subtitle: "குழந்தைகளுக்கான விளையாட்டு மற்றும் கற்றல்",
//       subscribeInfo1: "KidsZone Pro சேவைக்கு பதிவு செய்யவும்",
//       subscribeInfo2: "உங்களிடம் ரூ. 6+வரி/1 அறவிடப்படும்",
//       subscribe: "செயல்படுத்து",
//       dropdownSubscribe: "செயல்படுத்து",
//       dropdownTerms: "விதிமுறைகள் & நிபந்தனைகள்",
//     }
//   };
//   const terms = {
//     title: "Terms & Conditions",
//     list: [
//       "By clicking on subscribe, you agree to the following terms and conditions.",
//       "If you are a new customer, you will have the service free for one day then you will be charged as per selected pack.",
//       "Your subscription will be automatically renewed until you cancel or unsubscribe.",
//       "You can unsubscribe any time through the site by clicking on 'My Account' then 'Deactivate'.",
//       "You must be more than 18 years old to use this service.",
//       "If you are less than 18 years old, you MUST receive permission from the authorized person who pays your bill.",
//       "Standard data browsing costs will be applied.",
//       "For support, please contact us at support@nexgendigitalservices.lk"
//     ]
//   };
//   return (
//     <div className="flex flex-col min-h-screen bg-black text-white">
//       {/* Header */}
//       <header className="flex items-center justify-between p-4 bg-black shadow-lg relative z-50">
//         <div className="flex items-center space-x-2">
//           <img src={logo} alt="KidsZone Logo" className="h-10 w-auto" />
//         </div>
        
//         {/* Language Selector */}
//         <div className="flex space-x-2">
//           {Object.keys(translations).map(lang => (
//             <button 
//               key={lang}
//               className={`px-3 py-1 rounded-lg text-sm font-semibold ${selectedLanguage === lang ? 'bg-orange-500 text-white' : 'bg-gray-300 text-black'}`}
//               onClick={() => setSelectedLanguage(lang)}
//             >
//               {lang.toUpperCase()}
//             </button>
//           ))}
//         </div>

//         {/* Menu Button */}
//         <div className="relative">
//           <button onClick={() => setMenuOpen(!menuOpen)} className="text-white focus:outline-none">
//             {menuOpen ? <X size={28} /> : <Menu size={28} />}
//           </button>
//           {menuOpen && (
//             <div className="absolute top-12 right-4 bg-white text-black w-48 rounded-lg shadow-lg z-50 transition-all ease-in-out" tabIndex={0}>
//             <ul className="py-2">
//               <li className="px-4 py-2 cursor-pointer hover:bg-gray-200" onClick={handleSubscribe}>
//                 {translations[selectedLanguage].subscribe}
//               </li>
//               <li className="px-4 py-2 cursor-pointer hover:bg-gray-200"  onClick={() => window.location.href = "https://hutch.lk/vterms/"}>
//                 {translations[selectedLanguage].dropdownTerms}
//               </li>
//             </ul>
//           </div>
//           )}
//         </div>
//       </header>

//       {/* Main Content */}
//       <div className="flex flex-col justify-center items-center w-full min-h-screen p-6 md:p-10">
//         <div className="flex flex-col md:flex-row bg-black shadow-inner shadow-[#fff] rounded-lg w-full md:w-3/4 p-6 md:p-10 items-center gap-6">
//           {/* Animation */}
//           <div className="w-full md:w-1/3 flex justify-center">
//             <Lottie animationData={front} className="w-full max-w-[300px]" />
//           </div>

//           {/* Text and Subscribe Button */}
//           <div className="w-full md:w-2/3 flex flex-col text-center md:text-left space-y-4">
//             <h1 className="text-yellow-300 text-3xl md:text-4xl font-bold">{translations.en.title}</h1>
//             <h2 className="text-lg md:text-xl">{translations.en.subtitle}</h2>
//             <p className="text-gray-200 text-md md:text-lg font-semibold">{translations.en.subscribeInfo1}</p>
//             <p className="text-gray-300 text-sm md:text-md font-semibold">{translations.en.subscribeInfo2}</p>
//             <button onClick={handleSubscribe} className="bg-orange-500 text-white px-6 py-3 rounded-lg text-lg font-bold shadow-lg hover:bg-orange-600 transition">
//               {translations.en.subscribe}
//             </button>
//           </div>
//         </div>

//         {/* Terms and Conditions Section */}
//         <div className="mt-6 bg-black p-6 rounded-lg shadow-lg max-w-3xl w-full">
//           <h3 className="text-xl font-bold mb-4">{terms.title}</h3>
//           <ul className="list-disc text-justify  text-gray-300">
//             {terms.list.map((term, index) => (
//               <li key={index} className="mb-2 text-sm md:text-md">{term}</li>
//             ))}
//           </ul>
//         </div>
//       </div>

//     </div>
//   );
// };

// export default KidsZonePro;


import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import axios from 'axios';
import Lottie from 'lottie-react';
import front from '../Animations/front.json';
import { Menu, X } from "lucide-react";
import logo from '../assets/kids.png';

const KidsZonePro = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("en"); 
  const msisdn = Cookies.get('kidszonepro_user');
  
  useEffect(() => {
    if (msisdn) {
      navigate('/');
    } else {
      axios.get('/getheaders')
        .then(response => {
          const data = response.data;
          if (data.status == '1') {
            Cookies.set('kidszonepro_user', data.msisdn, { expires: 1 });
            Cookies.set('status', data.status, { expires: 1 });
            navigate('/');
          }
        })
        .catch(error => console.error("Error fetching data:", error));
    }
  }, [msisdn, navigate]);

  const handleSubscribe = () => {
    window.location.href = "http://consent.hutch.lk/register-service/VA%3D%3DCQ%3D%3DdQ%3D%3D";
  };

  const translations = {
    en: {
      title: "KIDSZONE PRO",
      subtitle: "Fun Learning for Kids",
      subscribeInfo1: "Subscribe to KidsZone Pro service",
      subscribeInfo2: "You will be charged Rs. 6+tax/1 apply",
      subscribe: "Subscribe",
       dropdownSubscribe: "Subscribe",
      dropdownTerms: "Terms & Conditions",
    },
    si: {
      title: "KIDSZONE PRO",
      subtitle: "දරුවන් සඳහා විනෝදය සහ ඉගෙනුම",
      subscribeInfo1: "KidsZone Pro සේවාවට දායක වන්න",
      subscribeInfo2: "ඔබට Rs. 6+බදු/1 අය වේ",
      subscribe: "සක්‍රිය කරන්න",
            dropdownSubscribe: "සක්‍රිය කරන්න",
      dropdownTerms: "නියම සහ කොන්දේසි",
    },
    ta: {
      title: "KIDSZONE PRO",
      subtitle: "குழந்தைகளுக்கான விளையாட்டு மற்றும் கற்றல்",
      subscribeInfo1: "KidsZone Pro சேவைக்கு பதிவு செய்யவும்",
      subscribeInfo2: "உங்களிடம் ரூ. 6+வரி/1 அறவிடப்படும்",
      subscribe: "செயல்படுத்து",
            dropdownSubscribe: "செயல்படுத்து",
      dropdownTerms: "விதிமுறைகள் & நிபந்தனைகள்",
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-black text-white">
      <header className="flex items-center justify-between p-4 bg-black shadow-lg relative z-50">
        <div className="flex items-center space-x-2">
          <img src={logo} alt="KidsZone Logo" className="h-10 w-auto" />
        </div>
        <div className="flex space-x-2">
          {Object.keys(translations).map(lang => (
            <button 
              key={lang}
              className={`px-3 py-1 rounded-lg text-sm font-semibold ${selectedLanguage === lang ? 'bg-orange-500 text-white' : 'bg-gray-300 text-black'}`}
              onClick={() => setSelectedLanguage(lang)}
            >
              {lang.toUpperCase()}
            </button>
          ))}
        </div>

        <div className="relative">
          <button onClick={() => setMenuOpen(!menuOpen)} className="text-white focus:outline-none">
            {menuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
          {menuOpen && (
            <div className="absolute top-12 right-4 bg-white text-black w-48 rounded-lg shadow-lg z-50 transition-all ease-in-out">
              <ul className="py-2">
                <li className="px-4 py-2 cursor-pointer hover:bg-gray-200" onClick={handleSubscribe}>
                  {translations[selectedLanguage].dropdownSubscribe}
                </li>
                <li className="px-4 py-2 cursor-pointer hover:bg-gray-200" onClick={() => window.location.href = "https://hutch.lk/vterms/"}>
                  {translations[selectedLanguage].dropdownTerms}
                </li>
              </ul>
            </div>
          )}
        </div>
      </header>
      <div className="flex flex-col justify-center items-center w-full min-h-screen p-6 md:p-10">
        <div className="flex flex-col md:flex-row bg-black shadow-inner shadow-[#fff] rounded-lg w-full md:w-3/4 p-6 md:p-10 items-center gap-6">
          <div className="w-full md:w-1/3 flex justify-center">
            <Lottie animationData={front} className="w-full max-w-[300px]" />
          </div>
          <div className="w-full md:w-2/3 flex flex-col text-center md:text-left space-y-4">
            <h1 className="text-yellow-300 text-3xl md:text-4xl font-bold">{translations[selectedLanguage].title}</h1>
            <h2 className="text-lg md:text-xl">{translations[selectedLanguage].subtitle}</h2>
            <p className="text-gray-200 text-md md:text-lg font-semibold">{translations[selectedLanguage].subscribeInfo1}</p>
            <p className="text-gray-300 text-sm md:text-md font-semibold">{translations[selectedLanguage].subscribeInfo2}</p>
            <button onClick={handleSubscribe} className="bg-orange-500 text-white px-6 py-3 rounded-lg text-lg font-bold shadow-lg hover:bg-orange-600 transition">
              {translations[selectedLanguage].subscribe}
            </button>
          </div>
        </div>
        <div className="mt-6 bg-black p-6 rounded-lg shadow-lg max-w-3xl w-full">
          <h3 className="text-xl font-bold mb-4">Terms & Conditions</h3>
          <ul className="list-disc text-justify text-gray-300">
            <li>By clicking on subscribe, you agree to the following terms and conditions.</li>
            <li>If you are a new customer, you will have the service free for one day then you will be charged as per selected pack.</li>
            <li>Your subscription will be automatically renewed until you cancel or unsubscribe.</li>
            <li>You can unsubscribe any time through the site by clicking on 'My Account' then 'Deactivate'.</li>
            <li>You must be more than 18 years old to use this service.</li>
            <li>If you are less than 18 years old, you MUST receive permission from the authorized person who pays your bill.</li>
            <li>Standard data browsing costs will be applied.</li>
            <li>For support, please contact us at support@nexgendigitalservices.lk</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default KidsZonePro;